( function( $ ) {
	'use strict';

	$( function() {
		$('.jsFAQItemHead').on('click', function(e) {
			e.preventDefault();

			$(this).parent().closest('.jsFAQItem').toggleClass('is-active');
			$(this).parent().closest('.jsFAQItem').find('.jsFAQItemBody').slideToggle();
		});
	} );
} )( jQuery );
